import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    Row, Col, Breadcrumb, BreadcrumbItem, Form, FormGroup, Input, Button, Label, NavItem,Nav, NavLink
} from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import {
    checkDuplicateCounterParty, checkDuplicateZone,
    appliedPortfolioFilters, filterValueListRemove, 
    deleteAppliedFilterList, SearchRequestBody, portfolioDataHandle, 
    sortDataByKey, sortByDate, checkAllCheckboxMethod, setCounterpartyList, setInitialValues,
    pageLink, currentLink, paginatedRequestBody, createFilterUrl, getUrlFilter, updateAppliedFiltersFunction
} from './helper';
import './my-portfolio.scss';
import * as PortfolioConstants from './constants';
import classnames from 'classnames';
import CasePortfolio from './case-portfolio/index';
import CUGPortfolio from './cug-portfolio/index';
import {  getUserInfo } from '../../helper';
// import moment from 'moment';
import {
    fetchPortfolioDetails,
    searchPortfolio,
    fetchRiskLevels,
    fetchProductNameFilterList,
    fetchRiskScoreTrendFilter,
    fetchCaseStatusFilter,
    fetchBusinessSegmentFilter,
    fetchLegalConstitutionFilter,
    fetchProductTypeDetails,
    searchPortfolioSuccess,
    setPortfolioFilters,
    fetchCugCorpData,
    fetchCaseType
} from './action';
// import Modal from '../../components/UI/Modal/Modal';
import { viewSelectedCounterpartySuccess } from '../corporate/action';
import { getCounterpartyType, getZone, getPortfolioCount } from '../../Analyst/Cases/Create/actions'
import { setFilters } from '../dashboard/action';
import { MODAL_TYPE_SUCCESS, MODAL_TYPE_FORM } from '../../constants';
import { ProductTypesPop } from '../productTypesPop';
import { Preloading } from '../../components/UI/Preloader/action';
import { toast } from 'react-toastify';

class MyPortfolio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clearFlag: false,
            sortFlag: true,
            showModal: false,
            body: null,
            modalType: MODAL_TYPE_FORM,
            modalTitle: '',
            modalCloseHandler: () => { },
            checkedAll: false,
            initialValues: {},
            selectedPortfolioData: [],
            sortType: PortfolioConstants.SORT_TYPE_DESCENDING,
            sortField: PortfolioConstants.DEFAULT_SORT_FIELD,
            searchText: '',
            selectedCountry: '',
            selectedState: [],
            activeTab : PortfolioConstants.INVESTIGATED
        };
    }

    componentDidMount(){
        this.props.getZone();
        this.props.fetchCounterPartyType();
        this.props.fetchRiskLevels();
        this.props.fetchProductNameFilterList();
        this.props.fetchRiskScoreTrendFilter();
        this.props.fetchCaseStatusFilter();
        this.props.fetchBusinessSegmentFilter();
        this.props.fetchLegalConstitutionFilter();
        let userInfo = getUserInfo();
        this.props.fetchCugCorpData(userInfo.corporateId);
        this.props.fetchCaseType();
        this.props.getPortfolioCount();
        if(this.props.location.pathname.indexOf("my-portfolio") != -1){
            this.setState({ activeTab : PortfolioConstants.INVESTIGATED })
        }else if (this.props.location.pathname.indexOf("cug-portfolio") != -1){
            this.setState({ activeTab : PortfolioConstants.CUG_PORTFOLIO })
        }

        if(this.props.redirectTabFromHome){
            if(this.props.redirectTabFromHome === 'Premium Business Check'){
                this.toggleDashboard(PortfolioConstants.INVESTIGATED);
            }else if (this.props.redirectTabFromHome === 'Business Profile Report'){
                this.toggleDashboard(PortfolioConstants.SUBSCRIPTION)
            }else if (this.props.redirectTabFromHome === 'KYC Report'){
                this.toggleDashboard(PortfolioConstants.KYC)
            }else if (this.props.redirectTabFromHome === 'Other Reports'){
                this.toggleDashboard(PortfolioConstants.OTHERS)
            }
        }
    }


    toggleDashboard = ( type ) => {
        if(type !== this.state.activeTab && type === PortfolioConstants.SUBSCRIPTION){
            this.props.history.push("/my-portfolio/1");
            this.setState({ activeTab : type });
        }
        else if(type !== this.state.activeTab && type === PortfolioConstants.INVESTIGATED){
            this.props.history.push("/my-portfolio/1");
            this.setState({ activeTab : type });
        }
        else if(type !== this.state.activeTab && type === PortfolioConstants.KYC){
            this.props.history.push("/my-portfolio/1");
            this.setState({ activeTab : type });
        }
        else if(type !== this.state.activeTab && type === PortfolioConstants.OTHERS){
            this.props.history.push("/my-portfolio/1");
            this.setState({ activeTab : type });
        }
       else if(type !== this.state.activeTab && type === PortfolioConstants.CUG_PORTFOLIO){
            this.props.history.push("/cug-portfolio/1");
            this.setState({ activeTab : type });
        }
    }

    render() {
        return (
            <Col className="my-portfolio">
                <Breadcrumb className="mb-3">
                    <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                    <BreadcrumbItem active>My Portfolio</BreadcrumbItem>
                </Breadcrumb>
                <Nav tabs>
                <NavItem>
                        <NavLink 
                        style ={{ marginRight : '5px',width : '255px'}}
                        disabled={this.props.portfolioCount !== undefined && this.props.portfolioCount.INVESTIGATED_REPORT > 0 ? false : true}
                        className={ `${classnames({ active: this.state.activeTab === PortfolioConstants.INVESTIGATED })}`}
                        onClick = { () => this.toggleDashboard(PortfolioConstants.INVESTIGATED)} role='button' href='#'>
                            <center>
                            Premium Business Check  
                            </center>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink 
                        style ={{ marginRight : '5px', width : '255px'}}
                        disabled={this.props.portfolioCount !== undefined && this.props.portfolioCount.SUBSCRIPTION_REPORT > 0 ? false : true}
                        className={ `${classnames({ active: this.state.activeTab === PortfolioConstants.SUBSCRIPTION })}`}
                        onClick = { () => this.toggleDashboard(PortfolioConstants.SUBSCRIPTION)} role='button' href='#'>
                            <center>
                            Business Profile Report 
                            </center>
                        </NavLink>
                    </NavItem>
                    
                    <NavItem>
                        <NavLink 
                        style ={{ marginRight : '5px' , width : '255px'}}
                        disabled={this.props.portfolioCount !== undefined && this.props.portfolioCount.KYC_REPORT > 0 ? false : true}
                        className={ `${classnames({ active: this.state.activeTab === PortfolioConstants.KYC })}`}
                        onClick = { () => this.toggleDashboard(PortfolioConstants.KYC)} role='button' href='#'>
                            <center>
                            KYC Report  
                            </center>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink 
                        style ={{ marginRight : '5px' , width : '255px'}}
                        disabled={this.props.portfolioCount !== undefined && this.props.portfolioCount.OTHERS > 0 ? false : true}
                        className={ `${classnames({ active: this.state.activeTab === PortfolioConstants.OTHERS })}`}
                        onClick = { () => this.toggleDashboard(PortfolioConstants.OTHERS)} role='button' href='#'>
                            <center>
                            Other Reports  
                            </center>
                        </NavLink>
                    </NavItem>
                    { this.props.cugCorporateDataSuccess.length > 0 &&
                        <NavItem>
                            <NavLink  className={classnames({ active: this.state.activeTab === PortfolioConstants.CUG_PORTFOLIO })}
                            onClick = { () => this.toggleDashboard(PortfolioConstants.CUG_PORTFOLIO)} role='button' href='#' >
                                CUG Portfolio
                            </NavLink>
                        </NavItem>
                    }
                </Nav>
                {
                    this.state.activeTab === PortfolioConstants.SUBSCRIPTION &&
                    <CasePortfolio 
                        {...this.props}
                        urlPageNumber={this.props.match.params.pageNumber}
                        urlSearch={this.props.location.search}
                        withoutRiskScore = {true}
                        reportCategory={this.state.activeTab}
                        >
                    </CasePortfolio>   
                }
                {
                    this.state.activeTab === PortfolioConstants.INVESTIGATED &&
                    <CasePortfolio
                    {...this.props} 
                        urlPageNumber={this.props.match.params.pageNumber}
                        urlSearch={this.props.location.search}
                        withoutRiskScore = {false}
                        reportCategory={this.state.activeTab}
                        >
                    </CasePortfolio>   
                }
                {
                    this.state.activeTab === PortfolioConstants.KYC &&
                    <CasePortfolio 
                    {...this.props}
                        urlPageNumber={this.props.match.params.pageNumber}
                        urlSearch={this.props.location.search}
                        withoutRiskScore = {true}
                        reportCategory={this.state.activeTab}
                        >
                    </CasePortfolio>   
                }
                {
                    this.state.activeTab === PortfolioConstants.OTHERS &&
                    <CasePortfolio 
                    {...this.props}
                        urlPageNumber={this.props.match.params.pageNumber}
                        urlSearch={this.props.location.search}
                        withoutRiskScore = {true}
                        reportCategory={this.state.activeTab}
                        >
                    </CasePortfolio>   
                }
                {
                    this.state.activeTab === PortfolioConstants.CUG_PORTFOLIO &&
                    <CUGPortfolio 
                        urlPageNumber={this.props.match.params.pageNumber}
                        urlSearch={this.props.location.search}
                        >
                    </CUGPortfolio> 
                }
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    counterPartyData: state.createCase.dropdownData,
    zoneList: state.createCase.zoneList,
    portfolioCount: state.createCase.portfolioCountData,
    riskLevel: state.portfolio.riskLevelSuccess,
    reportType: state.portfolio.productNameListSuccess,
    legalConstitution: state.portfolio.legalConstitutionSuccess,
    businessSegment: state.portfolio.businessSegmentSuccess,
    riskTrend: state.portfolio.riskTrendSuccess,
    caseStatus: state.portfolio.caseStatusSuccess,
    caseType: state.portfolio.caseTypeSuccess,

    portfolioFilters: state.portfolio.portfolioFilters,

    // fetchPortfolioDetails()  call responses
    portfolioListData: state.portfolio.portfolioList,
    fetchPortfolioDetailsFailure: state.portfolio.portfolioListFailure, // failure for fetchPortfolioDetails() & searchPortfolio()

    searchPortfolioData: state.portfolio.searchPortfolioSuccess,

    productTypeDetails: state.portfolio.productTypeDetails,
    productTypeDetailsFailure: state.portfolio.productTypeDetailsFailure,

    createCase: state.createCase.result,
    dashBoardFilters: state.dashboard.portfolioFilters,
    portfolioListFailure: state.portfolio.portfolioListFailure,

    corporateColor: state.corporate.corporateColor,
    cugPortfoliioList :state.cugPortfolio.cugPortfoliioList,
    cugCorporateDataSuccess : state.portfolio.cugCorporateDataSuccess,
    redirectTabFromHome: state.home.redirectToPortfolio
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchPortfolioDetails: () => { dispatch(fetchPortfolioDetails()) },
    fetchCounterPartyType: () => { dispatch(getCounterpartyType()) },
    getZone: () => { dispatch(getZone()) },
    searchPortfolio: (data) => { dispatch(searchPortfolio(data)) },
    searchPortfolioSuccess: (data) => { dispatch(searchPortfolioSuccess(data)) },
    fetchRiskLevels: () => { dispatch(fetchRiskLevels()) },
    fetchProductNameFilterList: () => { dispatch(fetchProductNameFilterList()) },
    fetchRiskScoreTrendFilter: () => { dispatch(fetchRiskScoreTrendFilter()) },
    fetchCaseStatusFilter: () => { dispatch(fetchCaseStatusFilter()) },
    fetchBusinessSegmentFilter: () => { dispatch(fetchBusinessSegmentFilter()) },
    fetchLegalConstitutionFilter: () => { dispatch(fetchLegalConstitutionFilter()) },
    viewSelectedCounterpartySuccess: (data) => { dispatch(viewSelectedCounterpartySuccess(data)) },
    fetchProductTypeDetails: () => { dispatch(fetchProductTypeDetails()) },
    setFilters: (data) => { dispatch(setFilters(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
    setPortfolioFilters: (filterData) => { dispatch(setPortfolioFilters(filterData)) },
    fetchCugCorpData: (data) => {dispatch(fetchCugCorpData(data))},
    fetchCaseType: () => { dispatch(fetchCaseType()) },
    getPortfolioCount: () => { dispatch(getPortfolioCount())}
});
export default MyPortfolio = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyPortfolio)
